import { __decorate } from "tslib";
import { customElement } from 'lit/decorators.js';
import { DataTableCell } from './internal/data-table-cell.js';
import { styles as cellStyles } from './internal/data-table-cell.css.js';
let MdDataTableCell = class MdDataTableCell extends DataTableCell {
};
MdDataTableCell.styles = [cellStyles];
MdDataTableCell = __decorate([
    customElement('md-data-table-cell')
], MdDataTableCell);
export { MdDataTableCell };
//# sourceMappingURL=data-table-cell.js.map